import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

type IStatusColor = '' | 'green' | 'red' | 'magenta' | 'brown' | 'purple' | 'orange' | 'yellow' | 'mint' | 'blue' | 'darkblue' | 'carbon-gray';
type BaseStatusV2Color = 'green' | 'grey' | 'red' | 'purple' | 'orange' | 'pink' | 'turquoise' | 'blue' | 'yellow' | 'violet';

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseStatusV2',
  props: {
    text: null,
    color: null,
    colorType: { default: 'light' },
    isShadow: { type: Boolean },
    rounded: null
  },
  setup(__props: any) {

const props = __props as { text?: string, color?: string, colorType: 'light' | 'dark', isShadow?: boolean, rounded?: 'large' | 'medium' | 'small' | 'extra-small' }



const LEGACY_COLOR_MAP: Partial<Record<IStatusColor, BaseStatusV2Color>> = {
    green: 'green',
    red: 'red',
    magenta: 'pink',
    brown: 'grey',
    purple: 'purple',
    orange: 'orange',
    yellow: 'yellow',
    mint: 'turquoise',
    blue: 'blue',
    darkblue: 'violet',
    'carbon-gray': 'grey',
};

const translateLegacyColorName = (color: string | undefined): BaseStatusV2Color => {
    if (!color) return 'grey';
    const mapped = LEGACY_COLOR_MAP[color as IStatusColor];
    if (mapped) return mapped;
    const allowed: BaseStatusV2Color[] = ['green', 'grey', 'red', 'purple', 'orange', 'pink', 'turquoise', 'blue', 'yellow', 'violet'];
    return allowed.includes(color as BaseStatusV2Color) ? (color as BaseStatusV2Color) : 'grey';
};

const resolvedColor = computed<BaseStatusV2Color>(() => translateLegacyColorName(props.color));

return { __sfc: true,props, LEGACY_COLOR_MAP, translateLegacyColorName, resolvedColor }
}

})